<div class="container profile-outer-container">
    <div class="profile-container">
        <div class="user-menu">
            <ul class="menu-list">
                <li *ngFor="let item of menuItems" class="mb-2 p-2"
                    [style.background-color]="selectedMenu === item.id ? '#0F0F1F' : '#F9F9FB'"
                    (click)="openMenu(item.id)"
                    style="border-radius: 12px; width: 15.143rem; cursor: pointer; list-style-type: none;">
                    <img alt="dropdown icon" class="menu-img" [src]="item.img"
                        [style.filter]="selectedMenu === item.id ? 'invert(100%) sepia(100%) saturate(0%) hue-rotate(154deg)' : ''">
                    <span class="fm-prompt menu-text mx-2"
                        [style.color]="selectedMenu === item.id ? '#F9F9FB' : '#0F0F1F'">{{item.text}}</span>
                </li>
            </ul>
        </div>

        <div class="user-menu-body">
            <div class="user-menu-body-content">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>
